import React from 'react';
import { Link } from '@mm/components';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { useHistory } from 'react-router-dom';
import { SettingsRoutes } from '../../routes/settings-routes';

const downgradeWithCS = {
  header: 'Just 1 more step',
  message: (
    <div>
      <div>To cancel your subscription please </div>
      <div>
        <span>email at: </span>
        <Link isBlank href="mailto:cs@mobilemonkey.com" capitalize={false}>
          cs@mobilemonkey.com
        </Link>
      </div>
    </div>
  ),
};

export const useOpenConditionalDowngradeModal = () => {
  const { openConfirmFbDowngradeModal, openGeneralTextModal } =
    useModalActions();

  const history = useHistory();

  const openConditionalDowngradeModal = (
    ...args: Parameters<typeof openConfirmFbDowngradeModal>
  ) => {
    const modalProps = args[0];
    const { plan, facebookPage, tabId } = modalProps;

    // Note: facebookPage and tabId will not be defined for team subscriptions
    // But we anyway do not want them to be able to cancel on their own.
    if (plan.cancellableInUi && tabId && facebookPage) {
      history.push(
        SettingsRoutes.billing.cancel.getLink(tabId, facebookPage?.id),
      );
      return null;
    }

    return openGeneralTextModal(downgradeWithCS);
  };

  return {
    openConditionalDowngradeModal,
  };
};
